(() => {
  if (window.apothecaStorefrontReady) return;
  window.apothecaStorefrontReady = true;

  const mobile = window.matchMedia('(max-width: 600px)');
  const setSidebar = () => document.querySelectorAll('.sf-sidebar').forEach(el => { el.open = !mobile.matches; });
  setSidebar();
  mobile.addEventListener('change', setSidebar);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.sf-quick-add')) return;
    event.preventDefault();
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    if (button.disabled) return;
    const original = button.innerHTML;
    button.disabled = true;
    button.textContent = form.dataset.adding;
    status.textContent = '';
    try {
      const result = await fetch(`${form.action}.js`, {
        method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
      });
      const payload = await result.json();
      if (!result.ok) throw new Error(payload.description || form.dataset.error);
      status.textContent = form.dataset.added;
      try {
        const cartResult = await fetch(form.action.replace(/\/add$/, '') + '.js');
        if (cartResult.ok) {
          const cart = await cartResult.json();
          let count = document.querySelector('.cart-count');
          if (!count) {
            count = document.createElement('span');
            count.className = 'cart-count';
            document.querySelector('.header-cart')?.append(count);
          }
          count.textContent = cart.item_count;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        }
      } catch {}
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      button.innerHTML = original;
      button.disabled = false;
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-sf-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    url.hash = 'sf-products';
    window.location.assign(url);
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-sf-filter-form]')) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    for (const name of [...url.searchParams.keys()]) {
      if (name.startsWith('filter.') || name === 'page') url.searchParams.delete(name);
    }
    for (const [key, value] of new FormData(event.target)) {
      if (value !== '') url.searchParams.append(key, value);
    }
    url.hash = 'sf-products';
    window.location.assign(url);
  });
})();
